// extracted by mini-css-extract-plugin
export default {"root":"Header_root__1VFZv","title":"Header_title__CKeWK","icon":"Header_icon__DUy+N","leftIcon":"Header_leftIcon__ttD2+","rightIcon":"Header_rightIcon__-eCji"};